var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconApple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.88,9.49a7.55,7.55,0,0,1-1,2q-1,1.53-2,1.53a3.82,3.82,0,0,1-1.09-.25,3.38,3.38,0,0,0-1.18-.25,3,3,0,0,0-1.11.25,2.75,2.75,0,0,1-1,.27c-.79,0-1.58-.67-2.35-2A8,8,0,0,1,0,7.05,4.66,4.66,0,0,1,.88,4.12,2.71,2.71,0,0,1,3.1,3a5.33,5.33,0,0,1,1.38.23,5.13,5.13,0,0,0,1.08.24A3.83,3.83,0,0,0,6.68,3.2,4.59,4.59,0,0,1,8,2.94a2.87,2.87,0,0,1,1.67.51,3.66,3.66,0,0,1,.81.78,4.92,4.92,0,0,0-.89.92,2.78,2.78,0,0,0-.51,1.62,3,3,0,0,0,.54,1.74A2.4,2.4,0,0,0,10.88,9.49ZM8,.33a3,3,0,0,1-.23,1.06A3.28,3.28,0,0,1,7,2.47,2.17,2.17,0,0,1,6.15,3a4.14,4.14,0,0,1-.81.13,3.43,3.43,0,0,1,.61-2A3.06,3.06,0,0,1,7.9,0a.81.81,0,0,0,0,.09s0,.07,0,.08V.25S8,.31,8,.33Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconApple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-apple.47d6294dadc9892a26cfd2b3a906d597.svg";